import deleteShortcut from '../../../common/rest/delete-shortcut/index.tsx';

export type Response = {
	id: string;
};

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default async (baseUrl: string, projectId: string, id: string): Promise<void> =>
	deleteShortcut(baseUrl, projectId, id);
